import http from '../../plugins/axios';

export default {

    queryOrderList(data){
        return http.get({
            url: 'admin/hedge/order/list',
            data
        })
    },

    exportHedgeStatistic(data){
        return http.post({
            url: '/admin/hedge/export',
            data,
            dataType: 'form',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    manualRiskHedge(data){
        return http.post({
            url: '/admin/hedge/manual',
            data,
            dataType: 'form'
        })
    },

    queryHedgeStatistic(data){
        return http.get({
            url: 'admin/hedge/statistic',
            data
        })
    },

    queryProfitAndLossStatistic(data){
        return http.get({
            url: 'admin/hedge/profit/loss',
            data
        })
    },
    findRiskHedgeStrategies(data){
        return http.get({
            url: 'admin/hedge/conf/list',
            data
        })
    },
    updateRiskHedgeStrategy(data){
        return http.post({
            url: '/admin/hedge/conf/update',
            data,
            dataType: 'form'
        })
    },
    getCurrentDirectionJudged(){
        return http.get({
            url: 'admin/hedge/conf/direction',
        })
    },
    updateCurrentDirectionJudged(data){
        return http.post({
            url: '/admin/hedge/conf/direction',
            data,
            dataType: 'form'
        })
    },
    addStrategy(data){
        return http.post({
            url: '/admin/hedge/conf/add',
            data,
            dataType: 'form'
        })
    },
    updateStrategyStatus(data){
        return http.post({
            url: '/admin/hedge/conf/status',
            data,
            dataType: 'form'
        })
    },

}
